import React, { useEffect, useState, useRef } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import GanttChartRefreshableFixed from './GanttChartRefreshableFixed';

/**
 * Main Gantt Chart component for a project
 * @param {Object} props
 * @param {number|string} props.projectId - Project ID to display
 * @param {Function} props.onAddTask - Callback when add task is clicked
 * @param {Function} props.onEditTask - Callback when edit task is clicked 
 * @param {Function} props.onRefresh - Callback when chart is refreshed
 */
const GanttChartFixed = ({ projectId, onAddTask, onEditTask, onRefresh }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ganttRef = useRef(null);
  
  // Load initial data
  useEffect(() => {
    if (!projectId) {
      setError('Project ID is required');
      setLoading(false);
      return;
    }
    
    setLoading(false);
  }, [projectId]);
  
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }
  
  console.log('GanttChartFixed rendering with props:', { projectId, onAddTask, onEditTask, onRefresh });
  
  return (
    <Box sx={{ height: 'calc(100vh - 220px)', minHeight: '400px', width: '100%' }}>
      <GanttChartRefreshableFixed
        ref={ganttRef}
        projectId={projectId}
        onAddTask={onAddTask}
        onEditTask={onEditTask}
        onRefresh={onRefresh}
      />
    </Box>
  );
};

export default GanttChartFixed;